<template>
  <div class="main">
    <Header
      :show="true"
      title="告警处理"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <div style="padding: 12px">
        <van-button
          type="warning"
          block
          size="small"
          @click="handleProcessSelect"
        >
          批量处理告警
        </van-button>
      </div>
      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        @row-click="handleTableRowClick"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="expand"
          width="30px"
        >
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              inline
            >
              <div style="display: flex; width: 100%; flex-direction: column">
                <el-form-item label="告警日期">
                  {{ row.createTime | formatDate }}
                </el-form-item>
                <el-form-item label="告警内容">
                  {{ row.content }}
                </el-form-item>
                <el-form-item label="处理状态">
                  <el-tag
                    v-if="row.handleStatus === false"
                    type="warning"
                  >
                    待处理
                  </el-tag>
                  <el-tag
                    v-else-if="row.handleStatus === true"
                    type="info"
                  >
                    已处理
                  </el-tag>
                </el-form-item>
                <el-form-item label="处理人">
                  {{ row.handler }}
                </el-form-item>
                <el-form-item label="处理日期">
                  {{ row.handleTime | formatDate }}
                </el-form-item>
                <el-form-item label="操作">
                  <el-button
                    v-if="checkPermission([452])"
                    :disabled="row.handleStatus"
                    size="mini"
                    type="primary"
                    @click="handleProcess(row)"
                  >
                    处理告警
                  </el-button>
                </el-form-item>
              </div>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          type="selection"
          width="50"
          align="center"
        />
        <el-table-column
          label="序号"
          type="index"
          width="70"
        />
        <el-table-column
          label="告警内容"
          prop="content"
          show-overflow-tooltip
        />
        <el-table-column
          label="状态"
          prop="status"
          align="center"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.handleStatus === false"
              type="warning"
            >
              待处理
            </el-tag>
            <el-tag
              v-else-if="row.handleStatus === true"
              type="info"
            >
              已处理
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :pager-count="table.fullWidth > 380 ? 5 : 3"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="handleClickQuery"
      />
      <div style="height: 1rem; background-color: #ffffff" />
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import checkPermission from "@/utils/permission";
import { Dialog } from "vant";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { getList, batchWarningCheck } from "@/api/warning.js";
import dayjs from "dayjs";

export default {
  name: "ServiceBussinessTruck",
  filters: {
    formatDate(time) {
      if (!time) return time;
      return dayjs(time).format("YYYY-MM-DD");
    },
    formatTime(time) {
      if (!time) return time;
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      listQuery: {
        limit: 10,
        page: 1,
      },
      table: {
        listLoading: false,
        fullWidth: document.documentElement.clientWidth,
        key: 0,
        total: 0,
        data: [],
        selectRow: [],
      },
      handleRowKey(row) {
        return row.id;
      },
    };
  },
  computed: {
    ...mapGetters({
      userid: "user/userid",
      username: "user/username",
    }),
  },
  created() {
    this.handleClickQuery();
  },
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
    },
    handleClickRight() {
      this.$router.push({
        path: "/service/system/staff/create",
        query: {},
      });
    },
    handleTableRowClick(row, column, event) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleClickQuery() {
      const data = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
      };
      getList(data).then(({ data }) => {
        const listInfo = data.page;
        this.table.total = listInfo.total;
        this.table.data = listInfo.records;
      });
    },
    handleSelectionChange(selected) {
      this.table.selectRow = selected;
    },
    async handleProcessSelect() {
      if (!this.table.selectRow.length) {
        this.$toast("请先勾选要处理的告警");
        return;
      }
      await Dialog.confirm({
        title: "处理告警",
        message: "是否批量处理已勾选的告警信息？",
      });
      await batchWarningCheck({
        ids: this.table.selectRow.map((item) => item.id),
        checkBy: this.userid,
        checkName: this.username,
        remark: "",
        status: 1,
      });
      this.$toast("处理成功");
      this.handleClickQuery();
    },
    async handleProcess(row) {
      await Dialog.confirm({
        title: "处理告警",
        message: "是否确认此告警已处理？",
      });
      await batchWarningCheck({
        ids: [row.id],
        checkBy: this.userid,
        checkName: this.username,
        remark: "",
        status: 1,
      });
      this.$toast("处理成功");
      this.handleClickQuery();
    },
  },
};
</script>

<style lang="scss" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 25%;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F7F8FA;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}

::v-deep .el-table__expanded-cell {
  padding: 0;

  .el-form {
    padding: 4px 12px;

    .el-form-item {
      margin-bottom: 0;
      & + .el-form-item {
        margin-top: 12px;
      }

      .el-form-item__label {
        width: 7em;
        line-height: 2em;
      }
      .el-form-item__content {
        width: calc(100% - 8em);
        line-height: 2em;
      }
    }
  }
}
</style>
